import { useEffect } from 'react';
import { navigate, parse, usePath } from './router.ts';
import { useApp } from './store.ts';
import { Login } from './pages/Login.tsx';
import { Dashboard } from './pages/Dashboard.tsx';
import { SiteShell } from './pages/site/SiteShell.tsx';
import { WorkspaceShell } from './pages/workspace/WorkspaceShell.tsx';
import { Toast } from './ui/Toast.tsx';

export function App() {
  const path = usePath();
  const route = parse(path);
  const booted = useApp((s) => s.booted);
  const me = useApp((s) => s.me);
  const boot = useApp((s) => s.boot);

  useEffect(() => {
    void boot();
  }, [boot]);

  useEffect(() => {
    if (!booted) return;
    if (!me && route.name !== 'login') navigate('/login', true);
    if (me && route.name === 'login') navigate('/', true);
  }, [booted, me, route.name]);

  // Atajo de Framer para los ajustes: Mayús + coma.
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      if (target.closest('input, textarea, select, [contenteditable]')) return;
      if (e.shiftKey && e.key === '<') return; // teclado español: Mayús+coma da «;» o «<» según la distribución
      if (e.shiftKey && (e.code === 'Comma' || e.key === ',') && me) {
        e.preventDefault();
        navigate('/settings/account');
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [me]);

  if (!booted) return null;
  let page = null;
  if (route.name === 'login' || !me) page = <Login />;
  else if (route.name === 'site') page = <SiteShell key={route.id} id={route.id} section={route.section} />;
  else if (route.name === 'settings') page = <WorkspaceShell section={route.section} />;
  else page = <Dashboard filter={route.filter} />;
  return (
    <>
      {page}
      <Toast />
    </>
  );
}
